import React, { Suspense } from 'react';
import { useOutletContext } from 'react-router-dom';
import Popup from '@components/common/Popup/Popup';
import PopupContent from '@components/common/Popup/PopupContent/index';
import Body from '../../components/Body';
import constant from '@components/common/globalization';
import EmailReceipt from '@components/common/EmailReceipt';
import SmsReceipt from '@components/common/SmsReceipt';
import OutOfStock from '../../../../containers/Fireboard/hamContainers/OutOfStock';
import ExpandedView from '../../../Fireboard/components/ExpandedView/index';
import FullWidthModal from '../../../common/Modal/FullWidthModal';
import style from '../../../Fireboard/views/Desktop/desktop.module.css';
import Loader from '@components/common/Loader/newLoaderModal';
import BulkTextToPay from '../../../Fireboard/components/BulkTextToPay/index';
import ErrorOrders from '../../../Fireboard/components/ErrorOrders/index';

// import screens
const Desktop = props => {
  const {
    popup,
    isExpanded,
    setIsExpanded,
    setPopup,
    currency,
    countryCode,
  } = props;
  const {
    emailReceiptHandler,
    smsReceiptHandler,
    updateOrderStatus,
  } = useOutletContext();

  const getPopupContent = () => {
    if (!popup) return null;
    switch (popup.type) {
      case constant.EMAIL_RECEIPT:
        return (
          <EmailReceipt setPopup={setPopup} onSubmit={emailReceiptHandler} />
        );
      case constant.SMS_RECEIPT:
        return (
          <SmsReceipt
            setPopup={setPopup}
            onSubmit={smsReceiptHandler}
            defaultPhoneNumber={popup.metaData?.phoneNumber}
            defaultCountryCode={popup.metaData?.countryCode}
          />
        );
      case constant.BULK_TEXT_TO_PAY:
        return <BulkTextToPay currency={currency} countryCode={countryCode} />;
      case constant.OUT_OF_STOCK:
        return <OutOfStock setPopup={setPopup} />;
      case constant.ERROR_ORDERS:
        return <ErrorOrders setPopup={setPopup} />;
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };
  const getPopupViewType = () => {
    if (!popup) return null;
    let isFullWidth = false;
    switch (popup.type) {
      case constant.EMAIL_RECEIPT:
        isFullWidth = false;
        break;
      case constant.SMS_RECEIPT:
        isFullWidth = false;
        break;
      case constant.BULK_TEXT_TO_PAY:
        isFullWidth = true;
        break;
      case constant.OUT_OF_STOCK:
        isFullWidth = true;
        break;
      case constant.NOTIFICATIONS:
        isFullWidth = true;
        break;
      case constant.ERROR_ORDERS:
        isFullWidth = true;
        break;
      default: {
        isFullWidth = false;
        break;
      }
    }
    return isFullWidth;
  };

  return (
    <>
      <Popup visible={!!popup} fullPopupView={getPopupViewType()}>
        {getPopupContent()}
      </Popup>
      <Suspense fallback={<Loader />}>
        <FullWidthModal
          isOpen={isExpanded}
          customClass={style.modalContainerBg}
          customClass2="h-100"
          style={{ height: '100%' }}
        >
          <ExpandedView
            {...props}
            setIsExpanded={setIsExpanded}
            isExpanded={isExpanded}
            updateOrderStatus={updateOrderStatus}
          />
        </FullWidthModal>
      </Suspense>

      <div className="d-flex flex-column h-100">
        <div className="flex-grow-1 h-100">
          <Body {...props} />
        </div>
      </div>
    </>
  );
};
export default Desktop;
